/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useGlobalServices } from '../../providers/GlobalContextProvider';
import { ConfigStates } from '../../../core';

import type { ConfiguredFilterColumn } from '../interfaces';
import type { AdvancedFilterValue } from '../../AdvancedFilter';

export const useConfiguredAdvancedFilter = (
    sectionId: string,
    cols: ConfiguredFilterColumn<AdvancedFilterValue>[]
) => {
    const { configuratorService } = useGlobalServices();
    const sectionConfig = configuratorService?.getSectionConfig(sectionId);
    const isActionConfigExist = sectionId && sectionConfig;

    const preparedCols = cols.map(column => ({
        ...column,
        groups: column.groups.filter(group => group).map(group => ({
            ...group,
            items: group.items.filter(item => item),
        })),
    }));
    const configuredCols = (isActionConfigExist
        ? preparedCols.map(column => ({
            ...column,
            groups: column.groups.filter(group => sectionConfig.getAdvancedFilterState(group.id) === ConfigStates.Visible)
                .map(({ id, ...group }) => ({
                    ...group,
                    items: group.items.filter(item => sectionConfig.getAdvancedFilterState(item.id) === ConfigStates.Visible)
                        .map(({ id, ...item }) => item),
                })),
        }))
        : preparedCols).filter(col => col.groups.length !== 0);

    return {
        configuredCols,
    };
};
